function parseOverrides(decodedOverrides: string) {
  try {
    return JSON.parse(decodedOverrides) as System.ImportMap['imports'];
  } catch (error) {
    // eslint-disable-next-line no-console
    console.warn(
      '[Importmaps] There was an error when decoding or parsing the override params: ',
      error
    );
    return null;
  }
}

export function readOverridesFromMagicUrl(): void {
  const identifier = 'importmapOverrides';

  // Read url params
  const urlParams = new URLSearchParams(window.location.search);
  const encodedOverrides = urlParams.get(identifier);

  // Abort if identifier cannot be found in url
  if (encodedOverrides === null) return;

  // Reset overrides if the identifier is set to 'reset' and stop script execution
  if (encodedOverrides === 'reset') {
    window.importMapOverrides.resetOverrides();
    console.info('[Importmaps] Reset all overrides');
    return;
  }

  // Decode overrides into parsable text
  const decodedOverrides = window.atob(encodedOverrides);

  const overrides = parseOverrides(decodedOverrides);

  // Abort if overrides are faulty
  if (overrides === null) return;

  // Reset existing overrides so there are no complications
  window.importMapOverrides.resetOverrides();

  // Iterate over all provided overrides
  Object.entries(overrides).forEach(([key, value]) => {
    console.info('[Importmaps] Added override for', key, ':', value);
    window.importMapOverrides.addOverride(key, value);
  });
}
